import React, { useEffect, useState } from 'react';
import { Button } from 'reactstrap';

//API
import perfil_api from '../../../../api/perfil_api';
import usuario_api from '../../../../api/usuario_api';

//Components
import UsuarioStepper from './components/UsuarioStepper';
import TabelaListagem from '../../../../components/TabelaListagem/TabelaListagem';

//Constants
import { actionsTable } from '../../../../constants/MaterialTable';

//Context
import { useAuth } from '../../../../context/auth';

//Helpers
import { showMessage } from '../../../../helpers/message';


export default function Usuarios({ permissoes }) {
    const { setLoading } = useAuth();

    //variavel de edição dos campos
    const editavel = permissoes.filter(permissao => permissao.acao == "Editar").length > 0;

    //State para pegar os usuários
    const [listUsuarios, setListUsuarios] = useState([]);

    // state para pegar os perfis
    const [listPerfil, setListPerfil] = useState([]);

    //state para Editar o perfil
    const [usuario_id, setUsuario_id] = useState(null);

    //state para criar perfil
    const [usuarioNovo, setUsuarioNovo] = useState(false);

    // fucao para editar usuario
    const editarPerfil = (usuario) => {
        setUsuario_id(usuario.id);
    }

    //Ações que a tabela terá
    const actions = [
        editavel ?
            actionsTable.editar(editarPerfil)
            : actionsTable.visualizar(editarPerfil)
    ];

    //Cabeçalhos que a tabela terá
    const headers = [
        { value: "Nome", objectValue: "nome", align: "left" },
        { value: "Email", objectValue: "email", align: "left" },
        {
            value: "Perfil", objectValue: "perfil", align: "left", options: {
                customBodyRenderLite: (dataIndex) => {
                    return <>{listPerfil[dataIndex]?.identificacao}</>
                }
            }
        },
        { value: "Status", objectValue: "status", align: "left" }
    ];

    //Função que carrega a lista de usuários
    const loadUsuarios = () => {
        setLoading(true);
        usuario_api.getList().then(response => {
            setListUsuarios(response.data);
        }).catch(e => showMessage("Erro", e.message, "error", null))
            .finally(f => setLoading(false));
    };

    //Função que carrega a lista de perfis
    const loadPerfil = () => {
        setLoading(true);
        perfil_api.getList().then(response => {
            setListPerfil(response.data);
        }).catch(e => showMessage("Erro", e.message, "error", null))
            .finally(f => setLoading(false));
    };

    useEffect(() => {
        loadUsuarios();
        loadPerfil();
    }, []);

    //Função para voltar para listagem
    const handleVoltar = () => {
        setUsuarioNovo(false);
        setUsuario_id(null);
        loadUsuarios();
    }

    //Criar / Editar
    if (usuarioNovo || usuario_id) {
        return <UsuarioStepper
            id={usuario_id}
            handleVoltar={handleVoltar}
            editavel={editavel}
        />
    }


    return <>
        <div className='d-flex align-items-center justify-content-between mb-4'>
            <h4 className='text-secondary m-0'>Usuários</h4>
            {editavel &&
                <Button color='success' onClick={() => { setUsuarioNovo(true) }}>+ Cadastrar</Button>
            }
        </div >
        <TabelaListagem
            actions={actions}
            title={"Lista de usuários"}
            options={{ print: false, search: true, pagination: true }}
            headers={headers}
            items={listUsuarios}
        />
    </>
}